import { useState } from "react";

/**
 * Préférence UI persistée dans le localStorage (colonnes de grille, taille de
 * page…). Lecture unique au montage, écriture à chaque changement. Tolère un
 * localStorage indisponible (mode privé) ou corrompu : on retombe sur le défaut.
 */
export function useLocalPref<T>(key: string, fallback: T): [T, (v: T) => void] {
	const [value, setValue] = useState<T>(() => {
		try {
			const raw = window.localStorage.getItem(key);
			return raw !== null ? (JSON.parse(raw) as T) : fallback;
		} catch {
			return fallback;
		}
	});

	const set = (v: T) => {
		setValue(v);
		try {
			window.localStorage.setItem(key, JSON.stringify(v));
		} catch {
			/* quota / mode privé : la préférence reste pour la session courante */
		}
	};

	return [value, set];
}
